export const MODIFIER_KEY = 18;